import { Quote } from '@/application/shared/domain/Quote';
import { PlanListRepository } from '@/planList/domain/PlanListRepository';
import { PlanResponse } from '@/planList/domain/PlanResponse';
import axios, { AxiosError } from 'axios';
import { SfApiResponse, RawSfError } from '@hfc/ui-core';

export class DentalPlansApi implements PlanListRepository {

  public async getPlans (quoteData: Quote): Promise<SfApiResponse<Array<PlanResponse>>> {
    try {
      const axiosResponse = await axios.post(`${import.meta.env.VITE_APP_LEGACY_API_URL}/application/dental/plans`, quoteData);

      return {
        success: true,
        data: axiosResponse.data.data?.plans
      };
    } catch (error) {
      return {
        success: false,
        error: error as AxiosError<RawSfError>
      };
    }
  }

}
